const environmentLabels = {
    LOCAL: 'Local',
    HOMOLOG: 'Homologação',
    PRODUCTION: 'Produção'
}

export const getEnvironmentLabel = environment => environmentLabels[environment] || environment || '-'




// WEBPACK FOOTER //
// ./src/helpers/environment/environment-helper.js